import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["position"]
const _hoisted_2 = { class: "loan-option-card-header" }
const _hoisted_3 = { class: "loan-option-card-title" }
const _hoisted_4 = { class: "repayment-terms-tooltip" }
const _hoisted_5 = { class: "rate" }
const _hoisted_6 = { class: "rate-value" }
const _hoisted_7 = { class: "loan-option-card-content" }
const _hoisted_8 = { class: "loan-option-card-repayments" }
const _hoisted_9 = ["onClick"]

import { ref, computed, onMounted, onBeforeUnmount, PropType } from "vue";
import { useStore } from "vuex";
import PelLoanRepaymentOption from "@/components/pel-loan-configuration/PelLoanRepaymentOption.vue";
import RepaymentOptionsHeader from "@/components/pel-loan-configuration/RepaymentOptionsHeader.vue";
import VariableRateTooltip from "@/components/pel-loan-configuration/VariableRateTooltip.vue";
import { RateTypeIds } from "@/config/constants";
import { RatePlanVM } from "@/models/loanConfiguration";
import { PelLoanConfigurationDetails } from "@/models/pel";
import TooltipComponent from "@/components/shared/TooltipComponent.vue";
import Icon from "@/components/shared/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PelLoanOption',
  props: {
  item: {
    type: Object as PropType<RatePlanVM>,
    required: true,
  },
  position: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const store = useStore();

const props = __props;

const windowWidth = ref<number>(0);

const details = computed<PelLoanConfigurationDetails>(
  () => store.state.loanConfigurationModule.applicationInfo,
);

const savingChanges = computed<boolean>(() => store.state.loanConfigurationModule.savingChanges);

const hasRepaymentTermTooltip = computed<boolean>(() => {
  return (
    (props.item &&
      props.item?.repaymentTermDetails &&
      props.item?.repaymentTermDetails?.tooltipText !== null &&
      props.item?.repaymentTermDetails?.tooltipText !== undefined) === true
  );
});

const selectedRepaymentOption = computed(
  () => store.state.loanConfigurationModule.selectedRepaymentOption,
);

const isMobile = computed(() => windowWidth.value <= 576 && windowWidth.value >= 390);
const isXSmallMobile = computed(() => windowWidth.value <= 390);
const isVariableRate = computed<boolean>(() => props.item.rateTypeId === RateTypeIds.VARIABLE);

const cardTitle = computed(() =>
  isMobile.value || isXSmallMobile.value
    ? `${props.item.repaymentTerm} Year Term`
    : `${props.item.repaymentTerm} Year Repayment Term`,
);

async function updateRepaymentOption(repayment: any) {
  if (windowWidth.value <= 576 && !savingChanges.value) {
    await store.dispatch("loanConfigurationModule/setSelectedRatePlan", props.item);
    await store.dispatch("loanConfigurationModule/setSelectedRepaymentOption", repayment);
  }
}

function handleResize() {
  windowWidth.value = window.innerWidth;
}

onMounted(async () => {
  window.addEventListener("resize", handleResize);
  handleResize();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "loan-option-card",
    position: __props.position
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(cardTitle.value) + " ", 1),
        (hasRepaymentTermTooltip.value)
          ? (_openBlock(), _createBlock(TooltipComponent, { key: 0 }, {
              toggle: _withCtx(() => [
                _createElementVNode("sup", null, [
                  _createVNode(Icon, { icon: "info" })
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(__props.item?.repaymentTermDetails?.tooltipText), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "divider" }, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(__props.item.rateDisplay), 1),
          (isVariableRate.value)
            ? (_openBlock(), _createBlock(VariableRateTooltip, {
                key: 0,
                location: "left",
                option: __props.item
              }, null, 8, ["option"]))
            : _createCommentVNode("", true)
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", null, "Interest Rate", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(RepaymentOptionsHeader, {
        class: "loan-option-card-repayments-header mobile",
        inSchoolLabel: details.value?.monthlyInSchoolPaymentLabel,
        postSchoolLabel: details.value?.monthlyPostSchoolPaymentLabel
      }, null, 8, ["inSchoolLabel", "postSchoolLabel"]),
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.repayments, (repayment) => {
          return (_openBlock(), _createElementBlock("li", {
            key: repayment.repaymentTypeName,
            class: _normalizeClass({
            active: repayment === selectedRepaymentOption.value,
          }),
            onClick: ($event: any) => (updateRepaymentOption(repayment))
          }, [
            (_openBlock(), _createBlock(PelLoanRepaymentOption, {
              key: repayment.repaymentTypeName,
              ratePlan: __props.item,
              repayment: repayment,
              isMobile: isMobile.value,
              position: __props.position,
              active: repayment === selectedRepaymentOption.value
            }, null, 8, ["ratePlan", "repayment", "isMobile", "position", "active"]))
          ], 10, _hoisted_9))
        }), 128))
      ])
    ])
  ], 8, _hoisted_1))
}
}

})